// Section: Contact Component
import React, { useState } from 'react';
import { motion } from 'framer-motion';

const ContactInfoItem = ({ info, index }) => {
  const [imageError, setImageError] = useState(false);

  // Ensure the image path is correct
  const imagePath = info.icon.startsWith('/') ? info.icon : `/${info.icon}`;
  
  return (
    <motion.div
      key={index}
      initial={{ opacity: 0, y: 20 }}
      whileInView={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.4, delay: index * 0.1 }}
      viewport={{ once: true }}
      className="contact-info-item"
    >
      <div className="contact-info-icon">
        {imageError ? (
          <span>•</span>
        ) : (
          <img 
            src={imagePath}
            alt={info.title} 
            className="contact-info-icon-img" 
            onError={() => setImageError(true)}
          />
        )}
      </div>
      <div className="contact-info-content">
        <a 
          href={info.link}
          className="contact-info-link"
        >
          <span>{info.value}</span>
          {info.value2 && (
            <span>{info.value2}</span>
          )}
        </a>
      </div>
    </motion.div>
  );
};

const Contact = () => {
  const contactInfo = [
    {
      icon: "/location.png",
      title: "Adres",
      value: "Atatürk, Naci Topçuoğlu Bulvarı No:1/b",
      value2: "27560 Şehitkamil/Gaziantep",
      link: "#"
    },
    {
      icon: "/telephone.png",
      title: "Telefon",
      value: "0534 880 22 19",
      link: "tel:+905348802219"
    },
    {
      icon: "/email.png",
      title: "E-posta",
      value: "test@leventdalgin.com",
      link: "mailto:test@leventdalgin.com"
    }
  ];

  const socialLinks = [
    {
      name: "Instagram",
      icon: "/instagram.png",
      link: "#"
    },
    {
      name: "YouTube",
      icon: "/youtube.png",
      link: "#"
    }
  ];

  return (
    <section id="iletisim" className="contact-section">
      {/* Background Pattern */}
      <div className="contact-background-pattern"></div>

      <div className="contact-container">
        {/* Test images */}
        <div style={{display: 'none'}}>
          <img src="/location.png" alt="test" />
          <img src="/telephone.png" alt="test" />
          <img src="/email.png" alt="test" />
        </div>
        
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          viewport={{ once: true }}
          className="contact-header"
        >
          <h2 className="contact-title">
            <span className="contact-title-light">İletişime</span>
            <br />
            <span className="contact-title-gradient">Geçin</span>
          </h2>
          <p className="contact-description">
            Projeleriniz için bizimle iletişime geçin. Size en uygun çözümü birlikte bulalım.
          </p>
        </motion.div>

        <div className="contact-content">
          {/* Contact Information */}
          <motion.div
            initial={{ opacity: 0, x: -30 }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.6 }}
            viewport={{ once: true }}
            className="contact-info"
          >
            <div className="contact-info-section">
              <div className="contact-info-list">
                {contactInfo.map((info, index) => (
                  <ContactInfoItem key={index} info={info} index={index} />
                ))}
              </div>
            </div>
          </motion.div>

          {/* About Company and Social Media */}
          <motion.div
            initial={{ opacity: 0, x: 30 }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.6 }}
            viewport={{ once: true }}
            className="about-section"
          >
            {/* Social Media */}
            <div className="social-media-section">
              <div className="social-media-links">
                {socialLinks.map((social, index) => (
                  <motion.a
                    key={index}
                    href={social.link}
                    whileHover={{ scale: 1.1 }}
                    whileTap={{ scale: 0.95 }}
                    className="social-media-link"
                  >
                    <img src={social.icon} alt={social.name} className="social-media-icon" />
                  </motion.a>
                ))}
              </div>
            </div>
          </motion.div>
        </div>
      </div>

      {/* Footer */}
      <motion.footer
        initial={{ opacity: 0 }}
        whileInView={{ opacity: 1 }}
        transition={{ duration: 0.6 }}
        viewport={{ once: true }}
        className="contact-footer"
      >
        <div className="footer-container">
          <p className="footer-text">
            © 2020 Levent Dalğın Medya Ajansı – Tüm Hakları Saklıdır.
          </p>
        </div>
      </motion.footer>
    </section>
  );
};

export default Contact;